module.exports = __webpack_public_path__ + "img/price_list_nl.814dc2a2.png";